/* eslint-disable @typescript-eslint/no-explicit-any */
import querystring from "querystring";
import Client from "../shared/services/Client";

interface NewsLetterUpdateSubscriptionOptions {
    source: any;
    notify: boolean;
    optIn: boolean;
}

function updateSubscription(
    subscription: Subscription, email?: string, options?: NewsLetterUpdateSubscriptionOptions): Promise<any> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { source, notify = true, optIn = false } = options || {};
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const path = `/api/newsletters/update?${ querystring.stringify({ email, source, notify, optIn }) }`;

    return Client.put(path, subscription);
}

function globalUnsubscribe(subscription: Subscription, email: string, hash: string, source?: string): Promise<any> {
    return Client.put(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        `/api/newsletters/unsubscribe-all?${ querystring.stringify({ email, hash, source }) }`,
        subscription);
}

function fetchNewsletterData(email: string, hash: string): Promise<any> {
    return Client.get(`/api/newsletters/list?${ querystring.stringify({ email, hash }) }`);
}

function fetchSingleNewsletterData(newsletterListId: string, email: string, hash: string): Promise<any> {
    return Client.get(`/api/newsletters/data/${ newsletterListId }?${ querystring.stringify({ email, hash }) }`);
}

function validateEmailHash(email: string, hash: string): Promise<any> {
    return Client.get(`/api/newsletters/hash?${ querystring.stringify({ email, hash }) }`);
}

export default {
    updateSubscription,
    globalUnsubscribe,
    fetchNewsletterData,
    fetchSingleNewsletterData,
    validateEmailHash
};
